export const ARTICLES = {
  INTRODUCTION: 'Article introduction',
  INTRO_TEXT: 'articleIntroductionText',
  SECTION: 'Article section',
};

export default ARTICLES;
